(function () {
  'use strict';
  if (customElements.get('sloth-community')) return;
  const acts = {nap: 'The unapologetic nap.', sofa: 'Sofa. So good.', clouds: 'Head in the clouds.', tea: 'A very slow cuppa.', nothing: 'Absolutely nothing.'};
  const clean = (value, max) => typeof value === 'string' ? value.replace(/[\u0000-\u001f\u007f]/g, ' ').trim().slice(0, max) : '';
  const duration = value => value === 60 ? '1 hour' : value === 120 ? '2 hours' : value + ' minutes';
  class SlothCommunity extends HTMLElement {
    connectedCallback() {
      if (this.controller) return;
      this.controller = new AbortController();
      this.q = key => this.querySelector('[data-community="' + key + '"]');
      this.gift = null;
      const on = (element, event, handler) => element?.addEventListener(event, handler, {signal: this.controller.signal});
      const newsletter = this.querySelector('.sloth-newsletter');
      on(newsletter, 'submit', event => {
        if (!this.prepareSignup()) { event.preventDefault(); return; }
        if (this.dataset.signup !== 'shopify') {
          event.preventDefault();
          this.q('signup-status').textContent = 'This private preview does not save signups. The Shopify draft uses Shopify’s signup form. Your email has not been sent or stored.';
        }
      });
      const friendForm = this.q('friend-form');
      on(friendForm, 'submit', event => { event.preventDefault(); this.createFriendPass(); });
      on(friendForm, 'input', event => {
        this.q('friend-error').hidden = true;
        event.target.removeAttribute('aria-invalid');
        if (['friend-name', 'friend-act', 'friend-custom', 'friend-minutes'].includes(event.target.dataset.community)) {
          this.gift = null; this.q('friend-actions').hidden = true;
          this.q('friend-preview').hidden = true;
        }
        this.q('friend-custom-field').hidden = this.q('friend-act').value !== 'custom';
        this.updateEmailDraft();
      });
      on(friendForm, 'change', event => {
        if (['friend-name', 'friend-act', 'friend-custom', 'friend-minutes'].includes(event.target.dataset.community)) {
          this.gift = null; this.q('friend-actions').hidden = true; this.q('friend-preview').hidden = true;
        }
        this.q('friend-custom-field').hidden = this.q('friend-act').value !== 'custom';
        this.updateEmailDraft();
      });
      on(this.q('friend-download'), 'click', () => this.downloadFriendPass());
      on(this.q('friend-share'), 'click', () => this.shareFriendPass());
      on(this.q('friend-email-draft'), 'click', event => {
        if (!this.gift || !this.q('friend-email').checkValidity()) {
          event.preventDefault(); this.fail('Add a valid email, or leave it blank and choose a recipient in your email app.', this.q('friend-email'));
        } else {
          this.updateEmailDraft();
          this.q('friend-status').textContent = 'Your email app will open a draft. Add the downloaded picture pass if you like, then send it from there.';
        }
      });
    }
    disconnectedCallback() { this.controller?.abort(); this.controller = null; }
    prepareSignup() {
      const email = this.q('signup-email');
      const consent = this.q('signup-consent');
      const status = this.q('signup-status');
      if (!email || !consent) return false;
      if (!email.value.trim() || !email.checkValidity()) {
        status.textContent = 'Add a valid email address to join.'; email.focus(); return false;
      }
      if (!consent.checked) {
        status.textContent = 'Tick the email opt-in to join the newsletter. You can still create and share a pass without signing up.'; consent.focus(); return false;
      }
      const pass = document.querySelector('sloth-pass');
      const scope = pass || document;
      const act = scope.querySelector('[name="act"]:checked')?.value;
      const minutes = Number(scope.querySelector('[name="duration"]:checked')?.value);
      const tags = ['slomunity', 'newsletter', 'slomunity_email_consent_v1'];
      if (Object.hasOwn(acts, act) || act === 'custom') tags.push('slomunity_act_' + act);
      if ([15, 30, 60, 120].includes(minutes)) tags.push('slomunity_minutes_' + minutes);
      const interest = scope.querySelector('[data-sloth-id="product-interest"]')?.value;
      if (['shirt', 'hat', 'tote'].includes(interest)) tags.push('slomunity_interest_' + interest);
      this.q('signup-tags').value = tags.join(',');
      this.q('signup-first-name').value = clean((scope.querySelector('[data-sloth-id="pledge-name"]') || document.getElementById('pledge-name'))?.value, 32);
      status.textContent = '';
      return true;
    }
    fail(message, input) {
      this.q('friend-error').textContent = message; this.q('friend-error').hidden = false;
      if (input) { input.setAttribute('aria-invalid', 'true'); input.focus(); }
    }
    createFriendPass() {
      const name = clean(this.q('friend-name').value, 32);
      const act = this.q('friend-act').value;
      const custom = clean(this.q('friend-custom').value, 120);
      const minutes = Number(this.q('friend-minutes').value);
      if (!name) { this.fail('Who needs a little permission to pause? Add their first name.', this.q('friend-name')); return; }
      if ((!Object.hasOwn(acts, act) && act !== 'custom') || ![15, 30, 60, 120].includes(minutes)) { this.fail('Choose a lazy act and some time off.'); return; }
      if (act === 'custom' && !custom) { this.fail('Write their lazy act, or choose one from the list.', this.q('friend-custom')); return; }
      const renderer = window.SlothPassRenderer || window.SlothPass;
      if (!renderer) { this.fail('The pass picture is still loading. Try again in a moment.'); return; }
      this.gift = {version: 2, name, act, custom, minutes, location: '', snacks: '', passId: ''};
      this.q('friend-preview-image').src = renderer.dataUri(this.gift, true);
      this.q('friend-preview-image').alt = 'Sloth Pass for ' + name + ': ' + (act === 'custom' ? custom : acts[act]);
      this.q('friend-preview').hidden = false; this.q('friend-actions').hidden = false;
      this.q('friend-error').hidden = true;
      this.q('friend-status').textContent = name + ' is cleared for ' + duration(minutes) + ' of doing less. Their details are not added to the newsletter.';
      this.updateEmailDraft();
    }
    friendMessage() {
      if (!this.gift) return '';
      const p = this.gift;
      const from = clean(this.q('friend-from').value, 32);
      const message = clean(this.q('friend-message').value, 280);
      return 'Hi ' + p.name + ',\n\nHere’s your Sloth Pass. You’re officially cleared for ' + duration(p.minutes) + ' of doing less.\n\nYour lazy act: ' + (p.act === 'custom' ? p.custom : acts[p.act]) + '\n\n' + (message ? message + '\n\n' : '') + (from ? 'With a little lazy love,\n' + from + '\n\n' : '') + 'Slothmopolitan — Be Lazy for Good.\nhttps://slothmopolitan.com';
    }
    updateEmailDraft() {
      if (!this.gift) return;
      const email = clean(this.q('friend-email').value, 254);
      const recipient = this.q('friend-email').checkValidity() ? email : '';
      this.q('friend-email-draft').href = 'mailto:' + encodeURIComponent(recipient) + '?subject=' + encodeURIComponent('Your permission to pause, ' + this.gift.name) + '&body=' + encodeURIComponent(this.friendMessage());
    }
    filename() { return 'sloth-pass-for-' + (this.gift?.name.toLowerCase().replace(/[^a-z0-9]+/g, '-').replace(/^-|-$/g, '') || 'a-friend') + '.png'; }
    passBlob() {
      const renderer = window.SlothPassRenderer || window.SlothPass;
      const gift = this.gift && {...this.gift};
      if (!gift || !renderer) return Promise.reject(new Error('missing-pass'));
      return new Promise((resolve, reject) => {
        const canvas = document.createElement('canvas'); canvas.width = 1080; canvas.height = 1350;
        const context = canvas.getContext('2d'); if (!context) { reject(new Error('canvas')); return; }
        const picture = new Image();
        const timer = setTimeout(() => reject(new Error('timeout')), 10000);
        picture.onload = () => { clearTimeout(timer); context.drawImage(picture, 0, 0, 1080, 1350); canvas.toBlob(blob => blob ? resolve(blob) : reject(new Error('image')), 'image/png'); };
        picture.onerror = () => { clearTimeout(timer); reject(new Error('image')); };
        picture.src = renderer.dataUri(gift, true);
      });
    }
    async downloadFriendPass() {
      if (!this.gift) return;
      try {
        const filename = this.filename(); const blob = await this.passBlob();
        if (!this.isConnected) return;
        const url = URL.createObjectURL(blob); const link = document.createElement('a');
        link.href = url; link.download = filename; document.body.appendChild(link); link.click(); link.remove();
        setTimeout(() => URL.revokeObjectURL(url), 1000);
        this.q('friend-status').textContent = 'Pass download started. Attach the PNG to your email, or share it in your favourite chat.';
      } catch (_) { this.q('friend-status').textContent = 'The picture could not be downloaded here. The email draft still includes their personal permission to pause.'; }
    }
    async shareFriendPass() {
      if (!this.gift) return;
      try {
        const file = new File([await this.passBlob()], this.filename(), {type: 'image/png'});
        if (navigator.share && navigator.canShare?.({files: [file]})) {
          await navigator.share({files: [file], title: 'A Sloth Pass for ' + this.gift.name, text: this.friendMessage()});
          this.q('friend-status').textContent = 'Your friend’s pass is ready. A little lazy, passed on.'; return;
        }
        this.q('friend-status').textContent = 'Picture sharing is not available in this browser. Download their pass and attach it to an email or chat.';
      } catch (error) {
        this.q('friend-status').textContent = error.name === 'AbortError' ? 'No rush. Their pass is here when you’re ready.' : 'Use Download their pass or Open email draft to pass it on.';
      }
    }
  }
  customElements.define('sloth-community', SlothCommunity);
})();
